import React from "react";
import { Button } from "../../../components";
import { LearnMoreLink } from "./LearnMoreLink";

/**
 * Header for the Info Pages feature, showing title and contextual actions.
 * @param {{
 *   showActions: boolean,
 *   onCreateNewPage: () => void,
 *   children?: React.ReactNode
 * }} props
 */
export function Header({ showActions, onCreateNewPage, children }) {
	return (
		<div className="infopage__header">
			<div className="header__text">
				<h1 className="text-h1">Information Pages</h1>
				<p className="text-h2">
					Learn more about <LearnMoreLink />
				</p>
			</div>
			<div className="header__actions">
				{showActions && (
					<>
						<Button
							buttonType="primary"
							isActive
							onClick={onCreateNewPage}
							leftIcon="plus-circle"
						>
							Create new page
						</Button>
						{children}
					</>
				)}
			</div>
		</div>
	);
}
